import { createContext } from 'react';

const CustomEventTypesContext = createContext({});

export default CustomEventTypesContext;
